<form class="row w-100 mx-0" [formGroup]="benefitForm" (ngSubmit)="isValid()">
  <div class="col-12 mb-5 text-center">
    <h4>{{benefitData ? 'Edición ' : 'Creación '}}de categoría</h4>
  </div>
  <div class="col-12 col-xl-6">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Título de categoría</mat-label>
      <input type="text" formControlName="title" matInput placeholder="Ingresar título...">
    </mat-form-field>
  </div>
  <div class="col-12 col-xl-6">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Número de orden</mat-label>
      <input type="number" min="0" formControlName="order" matInput placeholder="Ingresar número de orden...">
    </mat-form-field>
  </div>
  <div class="col-12 col-xl-6 d-flex flex-column">
    <mat-label>Visible al filtrar</mat-label>
    <mat-radio-group formControlName="visibleFilter" aria-label="Visible al filtrar">
      <mat-radio-button [value]="1">Si</mat-radio-button>
      <mat-radio-button [value]="0">No</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="col-12 col-xl-6 d-flex flex-column">
    <mat-label>Visible en el carrusel</mat-label>
    <mat-radio-group formControlName="visibleCarousel" aria-label="Visible en el carrusel">
      <mat-radio-button [value]="1">Si</mat-radio-button>
      <mat-radio-button [value]="0">No</mat-radio-button>
    </mat-radio-group>
  </div>
  <button type="submit" class="vs-btn-blue mt-4" [disabled]="benefitForm.invalid">
    Guardar
  </button>
</form>